﻿import { distinctUntilChanged, from } from 'rxjs';
import { createEpicMiddleware } from 'redux-observable';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import dynamicMiddlewares from 'redux-dynamic-middlewares'
import { rootEpic } from './rootEpics';

// Register global reducers if needed.
const staticReducers = {};

// Function need to allow other modules to dynamically register their reducers.
function createReducer(asyncReducers) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
}

// Epic Middleware allow RxJS to work with Redux via Redux-Observable.
const epicMiddleware = createEpicMiddleware();

// Creates, configure, and export the global store.
export const store = configureStore({
  reducer: staticReducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(epicMiddleware).concat(dynamicMiddlewares),
});

// Observable store that notifies the latest changes.

export const store$ = from(store).pipe(distinctUntilChanged());
// Add a dictionary to keep track of the registered async reducers.
store.asyncReducers = {};

// Create an inject reducer function.
// This function adds the async reducer, and creates a new combined reducer.
store.injectReducer = (key, asyncReducer) => {
  store.asyncReducers[key] = asyncReducer;
  store.replaceReducer(createReducer(store.asyncReducers));
};

// Run the root 'epic'.
epicMiddleware.run(rootEpic);
export { epic$ } from './rootEpics';
